import { Trash } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import ConfirmationPopover from '@/components/ConfirmationPopover';
import { useGrid } from '@Components/Grid';
import { getInfo, DeleteEntity } from '@Components/Grid/components/Table/formatters';

export default function DeleteAllocation({ info }) {
  const { definitions: { entityName } } = useGrid()
  const { row } = getInfo(info)

  if (row.default) {
    return <>
      <ConfirmationPopover
        target={<DefaultTooltip content='Delete' side='left'><Trash size={16} /></DefaultTooltip>}
        title={<span>Delete {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name || row.description}`}</i></span>}
      >
        <h6>The default allocation can not be deleted, change another allocation to be default before delete this.</h6>
      </ConfirmationPopover>
    </>
  }

  return <DeleteEntity info={info} />
}
